/** Authentication */
export const KFM_WEB_AUTH_CONFIG_KEY = 'e-kaufmann-auth-config';
export const KFM_WEB_AUTH_CONFIG_KEY_BETA = 'e-kaufmann-auth-config-beta';

/** Settings */
export const KFM_WEB_PRINT_SETTINGS = 'kfm_web_print_settings';
export const KFM_WEB_SETTINGS = 'kfm_web_settings';

/** Use chatbot feature */
export const KFM_WEB_USE_CHATBOT = true;

/** Theming */
export const KFM_THEMING_KEY = 'theme';
export const KFM_THEMING_DARK = 'dark-theme';
export const KFM_THEMING_LIGHT = 'light-theme';

/* Kaufmann web timestamp for last sync with cloud */
export const KFM_WEB_LAST_CLOUD_SYNC = 'kfm_web_cloud_sync';

/* Kaufmann app settings */
export const KFM_APP_SETTINGS = 'kfm_app_settings';

/* Cloud worker settings */
export const KFM_CLOUD_WORKER_SETTINGS = 'usersettings';

/** Kaufmann app login id param */
export const KFM_APP_LOGIN_ID = 'kfm-app';

/* Kaufmann app initial cloud time */
export const KFM_APP_INITIAL_DOWNLOAD_TIME = 'kfm_app_cloud_time';

/* Kaufmann app initial cloud time */
export const KFM_APP_INITIAL_UPLOAD_TIME = 'kfm_app_upload_time';

/* Kaufmann app db path after first init */
export const KFM_APP_DBPATH = 'kfm_app_db';

export const KFM_APP_LAST_OPEN_VERSION = 'kfm_app_last_open_version';

export const KFM_BOOKING_MIGRATION_STATUS = 'kfm_booking_migration_status';

export const KFM_WEB_HELP_DOCS_URL =
  'https://hottgenroth.atlassian.net/wiki/spaces/DOC/pages/647102944/E-Kaufmann';

export const KFM_WEB_WHATS_NEW_URL =
  'https://hottgenroth.atlassian.net/wiki/spaces/NEW/pages/1938391128/E-Kaufmann+1.4';

export const KFM_WEB_SUPPORT_URL =
  'https://www.hottgenroth.de/M/KontaktCenter/Seite.html,73318,181810';
